import { makeObservable, observable } from 'mobx';

import { DeviceData, DeviceStatus } from 'chaika-frontend-types/frontend-cms';

import { List } from '@store/abstract/List';

import { Device } from './Device';
import { isDefined } from '@utils/isDefined';

export interface FilterParams {
    query?: string;
    organizationId?: string;
    typeId?: string[];
    status?: DeviceStatus;
}

export class DeviceList extends List<Device, DeviceData, FilterParams> {
    public static Name = 'deviceList' as const;

    @observable
    protected loadedOrganizationIds: Set<string> = new Set();

    constructor(params?: DeviceData[]) {
        super(params);
        makeObservable(this);
    }

    public get activeDevices(): DeviceData[] {
        return this.getFilteredValues({ status: DeviceStatus.Active });
    }

    public isOrganizationDevicesLoaded(organizationId: string): boolean {
        return this.loadedOrganizationIds.has(organizationId);
    }

    public addLoadedOrganizationId(organizationId: string): void {
        this.loadedOrganizationIds.add(organizationId);
    }

    public getOrganizationDeviceIds(organizationId: string): string[] {
        return this.getFilteredValuesIds({ organizationId });
    }

    public getOrganizationDevices(organizationId: string): DeviceData[] {
        return this.getFilteredValues({ organizationId });
    }

    protected filterValue(value: Device, { organizationId, status, query, typeId }: FilterParams): boolean {
        return (
            (this.filterFieldValueIncludesString(value, query, 'name') ||
                this.filterFieldValueIncludesString(value, query, 'aeTitle') ||
                this.filterFieldValueIncludesString(value, query, 'inventoryNumber')) &&
            this.filterFieldValueByArray(value, typeId, 'typeId') &&
            (isDefined(organizationId) ? value.organizationId === organizationId : true) &&
            (isDefined(status) ? value.status === status : true)
        );
    }

    protected create(params: DeviceData): Device {
        return new Device(params);
    }
}

export const deviceList = new DeviceList();
